// ONE shared Zelligio Connect wordmark (§2): "Zelligio" charcoal + "Connect" terracotta,
// same line, scales intentionally on small screens. Used by Admin/Dealer/Login/emails —
// never recreate the logo inline.
export function BrandLockup({ className = "", connectClassName = "text-terracotta" }) {
  return (
    <span className={`whitespace-nowrap ${className}`} data-testid="brand-lockup">
      Zelligio <span className={connectClassName}>Connect</span>
    </span>
  );
}
